@if (itemList().description; as description) {
  <p class="atmos-item-list__description">{{ description }}</p>
}

<div class="atmos-item-list">
  @for (n of nodes(); track n.node.guid) {
    <div class="atmos-item-list__node"
      [class.is-unlocked]="n.unlocked"
      [class.is-highlighted]="n.highlighted">
      <a class="atmos-item-list__link"
        [routerLink]="['/item', n.node.item.guid]"
        [queryParams]="{ showTipUnlock: '1' }"
        [skyTooltip]="n.node.item.name" [attr.aria-label]="n.node.item.name">
        <app-item-icon
          class="atmos-item-list__icon"
          [item]="n.node.item"
          [listNode]="n.node"
          [subIcons]="SUBICONS_ALL"
          [opaque]="opaqueNodes() || n.unlocked"
          size="default"></app-item-icon>
        @if (n.node.quantity && n.node.quantity > 1) {
          <span class="atmos-item-list__quantity">x{{ n.node.quantity }}</span>
        }
      </a>

      <button type="button"
        class="atmos-item-list__bar"
        [attr.aria-pressed]="n.unlocked"
        [attr.aria-label]="n.unlocked ? 'Lock item' : 'Unlock item'"
        (click)="onNodeClick($event, n.node)">
        <span class="atmos-item-list__cost" [attr.data-kind]="n.cost?.kind">
          @if (n.cost; as c) {
            <mat-icon [svgIcon]="c.icon"></mat-icon>
            <strong>{{ c.amount }}</strong>
          } @else {
            <span class="atmos-item-list__free">Free</span>
          }
        </span>
        <span class="atmos-item-list__toggle">
          <mat-icon>{{ n.unlocked ? 'lock' : 'lock_open' }}</mat-icon>
        </span>
      </button>

      @if (nodeOverlayTemplate(); as tpl) {
        <span class="atmos-item-list__overlay">
          <ng-container [ngTemplateOutlet]="tpl" [ngTemplateOutletContext]="{ $implicit: n.node }"></ng-container>
        </span>
      }
    </div>
  }
</div>
